import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Calendar, Check, Zap } from 'lucide-react';
import './Roadmap.css';

const Roadmap = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const milestones = [
    {
      phase: 'Phase I',
      quarter: 'Q4 2025',
      title: 'Devnet Launch',
      items: [
        'Validator Alpha Program initiation',
        'Core chain security testing',
        'Multi-tier security audits (CertiK, PeckShield, Trail of Bits)',
      ],
      status: 'upcoming',
    },
    {
      phase: 'Phase II',
      quarter: 'Q1 2026',
      title: 'Public Testnet',
      items: [
        'Cross-chain bridge MVP deployment',
        'Comprehensive developer documentation release',
        'Public testing program with bug bounty',
      ],
      status: 'upcoming',
    },
    {
      phase: 'Phase III',
      quarter: 'Q3 2026',
      title: 'Multi-L1 Settlement Live',
      items: [
        'Cross-chain finality mechanisms activated',
        'MLSE (Multi-L1 Settlement Engine) deployment',
        'Liquidity routing and atomic swaps enabled',
      ],
      status: 'upcoming',
    },
    {
      phase: 'Phase IV',
      quarter: 'Q4 2026',
      title: 'Mainnet 1.0',
      items: [
        'Full mainnet launch with production readiness',
        'DAO governance framework activation',
        '$NOMOX token migration to native chain',
      ],
      status: 'upcoming',
    },
    {
      phase: 'Phase V',
      quarter: '2027+',
      title: 'Financial Layer 3',
      items: [
        'Real-world asset (RWA) tokenization support',
        'Traditional FX market integration',
        'Institutional API suite and compliance tools',
      ],
      status: 'future',
    },
  ];

  return (
    <section id="roadmap" className="roadmap-alien" data-testid="roadmap-section" ref={ref}>
      <div className="section-container">
        <motion.div
          className="section-header-alien"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <div className="section-tag">
            <div className="tag-line"></div>
            <span className="tag-text">DEVELOPMENT TIMELINE</span>
            <div className="tag-line"></div>
          </div>
          <h2 className="section-title-alien">
            <span className="title-normal">DEVELOPMENT</span>
            <span className="title-highlight">ROADMAP</span>
          </h2>
          <p className="section-subtitle-alien">
            Our journey from devnet to production-grade multi-chain infrastructure
          </p>
        </motion.div>

        <div className="roadmap-timeline">
          {milestones.map((milestone, index) => (
            <motion.div
              key={index}
              className={`milestone-card-alien ${milestone.status}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              data-testid={`milestone-${index}`}
            >
              <div className="milestone-number">{index + 1}</div>
              
              <div className="milestone-header-alien">
                <div className="milestone-phase-badge">
                  <Zap size={14} />
                  {milestone.phase}
                </div>
                <div className="milestone-quarter">
                  <Calendar size={14} />
                  {milestone.quarter}
                </div>
              </div>

              <h3 className="milestone-title-alien">{milestone.title}</h3>

              <ul className="milestone-list">
                {milestone.items.map((item, idx) => (
                  <li key={idx} className="milestone-item-alien">
                    <Check size={16} className="check-icon" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              {index < milestones.length - 1 && <div className="timeline-connector"></div>}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Roadmap;